<div class="patient">
    <div class="wrapper">
        <header class="l-header">
            <div class="on-mobile header-logo">
                <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
            </div>
            <div *ngIf="ls.premissions" class="l-header-panel dsp-flex">
                <div *ngIf="ls.premissions.Appointments" id="1" class="header">
                    <button class="clear-btn" (click)="router.navigate(['/appointments']);">Appointments</button>

                </div>
                <div *ngIf="ls.premissions.Billings" id="1" class="header">
                    <button class="clear-btn" (click)="router.navigate(['/billings']);">Billings</button>
                </div>
            </div>
        </header>

        <main class="l-deashboard"></main>

        <aside class="l-sidebar l-flex l-column">
            <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

            <nav class="mainNav l-fg1 scroller"></nav>
            <app-docpanel></app-docpanel>
        </aside>

        <app-bottombar></app-bottombar>
    </div>

</div>
<app-commerror></app-commerror>